import Logo1 from "../../../assets/images/logo1.png";
import { useSelector } from "react-redux";
import "../CustomerRefundPrint.css";
import moment from "moment";
import { useMemo } from "react";
import Logo2 from "../../../assets/images/logo2.svg";

const CustomerRefundPrintHeader = () => {
  const { customerRefundPrint } = useSelector((state) => state);
  const headerData = customerRefundPrint && customerRefundPrint?.payload?.data[0];
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="65%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="50%">
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%">
                      <p className="__addr_table_heading">
                        Customer Refund Report
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" valign="top" style={{ paddingRight: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Transaction # :</td>
                            <td colSpan={3}>{headerData?.refund_header_no || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Posting Period :</td>
                            <td colSpan={3}>{headerData?.period_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Customer :</td>
                            <td colSpan={3}>{headerData?.customer_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Debit Account :</td>
                            <td colSpan={3}>{headerData?.account_name || ''}</td>
                          </tr>

                        </tbody>
                      </table>
                    </td>
                    <td width="50%" style={{ paddingLeft: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td valign="top">Date :</td>
                            <td colSpan={5}>{moment(headerData?.refund_date).format("MM-DD-YYYY") || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Memo :</td>
                            <td colSpan={5}>
                              {headerData?.memo || ''}
                            </td>
                          </tr>
                          <tr>
                            <td valign="top">A/R Account :</td>
                            <td colSpan={5}>{headerData?.ar_account_name || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Remarks :</td>
                            <td colSpan={5}>{headerData?.remarks || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CustomerRefundPrintHeader;
